import { Lightning, AppData, Metadata, Colors } from '@lightningjs/sdk';
import { extractUrlFromText, convertAnchorTagsToBold } from 'support/textUtils';
import { translate } from 'support/translate';
import SettingsQrCodeSection from './SettingsQrCodeSection';
import QrCodeContent from './contents/QrCodeContent';

export interface SupportSectionTemplateSpec
  extends Lightning.Component.TemplateSpec {
  Content: {
    SupportContent: typeof QrCodeContent;
    SupportQrCode: typeof SettingsQrCodeSection;
    AppVersion: typeof QrCodeContent;
    OsVersion: typeof QrCodeContent;
    DeviceId: typeof QrCodeContent;
  };
}

const CONTENT_SPACING = 48;
const INFO_MARGIN_TOP = 36;

export default class SupportSection
  extends Lightning.Component<SupportSectionTemplateSpec>
  implements
    Lightning.Component.ImplementTemplateSpec<SupportSectionTemplateSpec>
{
  private _Content = this.getByRef('Content')!;
  private _SupportContent = this._Content.getByRef('SupportContent')!;
  private _SupportQrCode = this._Content.getByRef('SupportQrCode')!;
  private _AppVersion = this._Content.getByRef('AppVersion')!;
  private _OsVersion = this._Content.getByRef('OsVersion')!;
  private _DeviceId = this._Content.getByRef('DeviceId')!;

  get title() {
    const supportContent = this._SupportContent.title;
    const appVersion = this._AppVersion.title;
    const osVersion = this._OsVersion.title;
    const deviceId = this._DeviceId.title;

    return [...supportContent, ...appVersion, ...osVersion, ...deviceId];
  }

  static override _template(): Lightning.Component.Template<SupportSectionTemplateSpec> {
    return {
      Content: {
        flex: { direction: 'column' },
        SupportContent: { type: QrCodeContent },
        SupportQrCode: {
          flexItem: { marginBottom: CONTENT_SPACING },
          type: SettingsQrCodeSection,
        },
        AppVersion: { type: QrCodeContent },
        OsVersion: {
          type: QrCodeContent,
          flexItem: { marginTop: INFO_MARGIN_TOP },
        },
        DeviceId: {
          type: QrCodeContent,
          flexItem: { marginTop: INFO_MARGIN_TOP },
        },
      },
    };
  }

  override async _active() {
    const supportContent = AppData!.config?.login.settings.support;
    if (!supportContent) return;

    const supportHeading = supportContent.support_center.title ?? '';
    const rawSupportDescription =
      supportContent.support_center.description ?? '';
    const supportUrl = extractUrlFromText(rawSupportDescription);
    const supportDescription = convertAnchorTagsToBold(rawSupportDescription);
    const appVersionTitle = supportContent.app_version.title ?? '';
    const osVersionTitle = supportContent.os_version.title ?? '';
    const deviceIdTitle = supportContent.device_id.title ?? '';

    this._SupportContent.heading = supportHeading;
    this._SupportContent.description = supportDescription;
    this._SupportQrCode.url = supportUrl;

    this._AppVersion.heading = appVersionTitle;
    this._OsVersion.heading = osVersionTitle;
    this._DeviceId.heading = deviceIdTitle;

    this._AppVersion.description =
      Metadata.appVersion() ?? translate('global.unknown');
    const deviceInfo = await AppData!.device.getDeviceInfo();
    this._OsVersion.description =
      deviceInfo.osVersion || translate('global.unknown');
    this._DeviceId.description = AppData!.mParticle.mpid ?? '';
  }
}
